import React, { useState, useRef } from 'react';

import { Users, Video } from 'lucide-react';
import Footer from '../components/Footer';

const testimonials = [
  {
    image: "/images/profile (2).png",
    name: "Siddarth Wasnik",
    text: "Prajakta Greenfinty project is good. It is situated in the heart of the city in Nagpur. As per my son, this project is very fine & Ashish sir is aware of the project very well."
  },
  {
    image: "/images/profile (2).png",
    name: "Dr. Vivek Nagarle",
    text: "Ashish Construction has built a very good project. The team members are very good. Ashish Londhe and his team did a great job. In compact space, they built a spacious apartment. Thank you for giving us our DREAM HOME."
  },
  {
    image: "/images/profile (2).png",
    name: "Manoj Sharma",
    text: "An absolutely phenomenal project with amazing construction quality."
  },
  {
    image: "/images/profile (2).png",
    name: "Anjali Fule",
    text: "Prajakta Greenfinity project quality is up to the mark. Beautiful design and amenities in such limited space — fabulous!"
  },
  {
    image: "/images/profile (2).png",
    name: "Dr. Ankita Randhir",
    text: "Very good and well-constructed project. Happy with the gym and party area interiors. Satisfied with the builder’s cooperation."
  },
  {
    image: "/images/profile (2).png",
    name: "Dr. Milind Suryawanshi",
    text: "It's a perfect project as per my opinion. Customer-friendly and built with passion. Mr. Ashish Sir truly builds homes from the heart."
  },
  {
    image: "/images/profile (2).png",
    name: "Dinesh Badoniya",
    text: "The construction of the scheme is very good, with adequate lighting and excellent design. Very well-planned layout."
  }
];

// 🆕 Local MP4 videos
const videos = [
  // { id: 1, src: "/prajakta_greenfinity.mp4" },
  { id: 2, src: "/testimonials/p_greenfinity.mp4" },
  { id: 3, src: "/testimonials/p_greenfinity3.mp4" },
  // { id: 4, src: "/testimonials/p_greenfinity4.mp4" },
  { id: 5, src: "/testimonials/p_greenfinity6.mp4" },
  { id: 6, src: "/Prajkta-greenfinity.mp4" },
  { id: 7, src: "/Prajkta-greenfinity2.mp4" },


];



const TestimonialCard = ({ image, name, text }) => (
  <div
    className="bg-white shadow-lg rounded-xl p-6 max-w-md text-center border-t-4"
    style={{ borderTopColor: "#011321" }}
  >
    <div className="flex justify-center">
      <img
        src={image}
        alt={name}
        className="w-24 h-24 rounded-full border-4 border-white shadow-md"
      />
    </div>
    <h4 className="text-[#011321] font-bold mt-4">{name}</h4>
    <p className="text-gray-600 text-sm italic mt-2">“{text}”</p>
    <div className="flex justify-center mt-4 text-[#011321]">
      {Array(5)
        .fill("⭐")
        .map((star, i) => (
          <span key={i}>{star}</span>
        ))}
    </div>
  </div>
);

const TestiminalPage = () => {
  const [activeTab, setActiveTab] = useState('clients');
  const videoRefs = useRef([]);
  const handlePlay = (index) => {
  videoRefs.current.forEach((video, i) => {
    if (i !== index && video) {
      video.pause();
    }
  });
};
  const tabs = [
    { id: 'clients', name: 'Clients Review', icon: Users },
    { id: 'video', name: 'Videos', icon: Video },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="relative pt-28 pb-20 text-white flex items-center justify-center"
        style={{
          backgroundImage: "url('/images/testimonials-heros.jpg')",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "90vh",
        }}
      >
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 sm:top-20 right-10 sm:right-20 w-48 sm:w-96 h-48 sm:h-96 bg-white rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 sm:bottom-20 left-10 sm:left-20 w-40 sm:w-64 h-40 sm:h-64 bg-white rounded-full blur-2xl"></div>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="py-6 bg-white border-b border-gray-200 sticky top-20 z-40 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-2">
            {tabs.map(tab => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === tab.id
                      ? 'bg-[#011321] text-white shadow-lg scale-105'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-[#011321]'
                    }`}
                >
                  <Icon className="w-5 h-5" />
                  <span>{tab.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Client Reviews */}
      {activeTab === 'clients' && (
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-800 mb-12">
              Client Testimonials
            </h2>
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {testimonials.map((t, index) => (
                <TestimonialCard key={index} {...t} />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Video Testimonials */}
      {activeTab === 'video' && (
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-800 mb-12">
              Video Testimonials
            </h2>

            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
             {videos.map((video, index) => (
                <div key={video.id} className="rounded-xl overflow-hidden shadow-lg bg-white">
                  <video
                    className="w-full h-60 object-cover"
                    controls
                    preload="metadata"
                    ref={(el) => (videoRefs.current[index] = el)}
                    onPlay={() => handlePlay(index)}
                  >
                    <source src={video.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div className="p-4 text-center">
                    <h4 className="font-semibold text-[#011321]">{video.title}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
};

export default TestiminalPage;

